"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @deprecated Use Router query to extract any params or there is another way with WhatWG URL API
 * @param fullPath
 */
function extractSearchQueryFromPath(fullPath = '') {
    // Prevent hash appearing
    const [path] = fullPath.split('#');
    const matchResult = /(^|\?|&)s=([^&]+)/.exec(path);
    return matchResult ? decodeURIComponent(matchResult[2]) : undefined;
}
exports.default = extractSearchQueryFromPath;
//# sourceMappingURL=extractSearchQueryFromPath.js.map